module.exports = __webpack_public_path__ + "img/cotoclub1.6f54a346.png";